import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router";
import {
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  Link,
  Button,
} from "@mui/material";
// import "../signUp/SignUp.css";
import "../../assets/styles/LSFR.css";
import { Form, Field, FormikProvider, useFormik } from "formik";
import JSEncrypt from "jsencrypt";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import * as Yup from "yup";
import Logo from "../../assets/images/StyLogo.png";
import { Notification } from "../../utils/Notification";
import API, { INTELLICONVO_API } from "../../utils/Axios.utils";
const Login = () => {
  const navigate = useNavigate();
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState("");
  const [alertType, setAlertType] = useState("");

  const handleAlert = () => {
    setAlert(false);
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Email must be a valid email address.")
      .trim()
      .email("Email must be a valid email address.")
      .trim()
      .required("Email is required."),

    password: Yup.string()
      // .matches(/^\S*$/, "Password must not contain spaces.") // No spaces allowed
      // .matches(
      //   /(?=.*[A-Z])/,
      //   "Password must contain at least one uppercase letter."
      // ) // At least one uppercase letter
      // .matches(
      //   /^(?=.*[a-z])/,
      //   "Password must contain at least one lowercase letter."
      // ) // At least one lowercase letter
      // .matches(/^(?=.*\d)/, "Password must contain at least one number.") // At least one number
      // .matches(
      //   /^(?=.*[!@#$%^&*])/,
      //   "Password must contain at least one special character."
      // ) // At least one special character
      // .min(8, "Password must be at least 8 characters long.") // Minimum password length of 8 characters
      // .max(20, "Password must be at most 20 characters long.")
      .required("Password is required."),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      remember: false,
    },
    validationSchema: LoginSchema,
    onSubmit: async () => {
      await onSubmit(formik);
    },
  });

  const onSubmit = async (formik) => {
    console.log('intelli :- ', INTELLICONVO_API);
    //     const encryptor = new JSEncrypt();
    //     const privateKey = `-----BEGIN RSA PRIVATE KEY-----
    // MIICWwIBAAKBgFs4OHUSYAhdP8pE+XrqmeUR+UpBIuQmH4EUuRC+5zsyNC5H4vVV
    // 0TpsBs21G0nr2D8mZF8zFlInqsr2JJieBTxr9VfcP6WdnSwuc895hyhAlghhL/hn
    // xbApGDBj+AkUD/WzRARtXdgtwHoNVhR+JD3MRY8N0A7qZHeQ7JNDhYRZAgMBAAEC
    // gYATRfqvybUer00mGJK5xM3FV5nbdY3AtMldRZqgjiVfHYlm6etrOLmfZWm+lvBw
    // GvOyzBLTBoFF1HnCrmUnFeQ3EmjbIZPlSR8UQrjbZXOYHcDO41dK7xLWGGIsC8wd
    // rbcsGpT3U1WhIsjmfk3vmU/qSszbat1dCK7vom1j2CjrLQJBAJljwXxtXi80FT23
    // DnRmzDXoIYz6LUGQ6heEPby4ukM7+EwPdZPIn0yuw4lOvKmwdxm+M25LOuZc2rmb
    // xqlSH0cCQQCYPbxEJQ0e3pJ/bHWfCYRDwJ4wEo0BTw9n0YEQqVhI2nbC5z5w7K3X
    // 9D0CqXIPNyAJFe51Qohv2dTChDVq809fAkBzhmVAYGKyLIje7VLuqkmdRBKYygdx
    // vUIBqjCRRZPLdYxBRNdqEYygxXMxo+KF7wkUk2LK69AVldOKPV+3QMmbAkBAPyVZ
    // OK2dzl3Simnk0LZRhVL8hIee+sdMj7xA1MZeEFu4CrBuJWOD1B1/JxTsWN4bF3dH
    // YumDElFYOUT1unJPAkEAgcankqb0byKylQq7cZj6Pw12ckttfOHxkj0X7aBTV7wz
    // 2vTZgwpP8GpZwbBV6PEr6aypOhB3SmS7ugN2t7XDoA==
    // -----END RSA PRIVATE KEY-----`;
    //     encryptor.setPublicKey(privateKey);
    //     const encryptedPassword = encryptor.encrypt(formik.values.password); // encrypt

    //     if (!encryptedPassword) {
    //       throw new Error("Password encryption failed. Please try again.");
    //     }

    // 2. Prepare Data
    // const data = {
    //   email: formik.values.email,
    //   encryptedPassword: encryptedPassword, // Send encrypted password
    // };
    const data = {
      email: formik.values.email,
      password: formik.values.password, // Send encrypted password
    };
    const headers = {
      "Content-Type": "application/json",
    };
    await INTELLICONVO_API.post("/auth/user/login", data, headers)
      .then(async (res) => {
        console.log('intelli :- ', res?.data);

        const loginData = res?.data || {};

        // Intelliconvo's top-level role/role_id/is_admin can be stale — they
        // reflect whichever role the account was first created with, and
        // don't update when Admin access is granted later under a specific
        // application. So also check applications[] for an explicit Admin
        // assignment (matched by role_name, since role_id/app_id differ per
        // org/customer) and let it win. This only ever elevates to Admin —
        // the original top-level fields are left untouched otherwise, so
        // every other role keeps working exactly as it does today.
        const applications = Array.isArray(loginData.applications) ? loginData.applications : [];
        const adminAppEntry = applications.find(
          (app) => (app.role_name || "").trim().toLowerCase() === "admin"
        );
        if (adminAppEntry && (loginData.role || "").toLowerCase() !== "admin") {
          console.log(`[Login] Elevating to Admin via applications[] match (top-level role was: ${loginData.role})`);
          loginData.role = "Admin";
          loginData.role_id = adminAppEntry.role_id;
          loginData.is_admin = true;
        }

        localStorage.setItem("userLoggedIn", JSON.stringify(loginData));
        if (loginData?.token) {
          localStorage.setItem("token", loginData.token);

          // Record login in audit log
          API.post("/api/users/login-audit").catch((err) => {
            console.warn("Failed to record login audit:", err);
          });
          
          // Sync token with FastAPI automation backend
          try {
            const syncUrl = process.env.REACT_APP_FASTAPI_SYNC_URL;
            if (syncUrl) {
              await fetch(syncUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token: loginData.token })
              });
              console.log("✅ Token successfully synced to FastAPI automation service!");
            } else {
              console.warn("⚠️ REACT_APP_FASTAPI_SYNC_URL is not defined in .env");
            }
          } catch (syncErr) {
            console.error("Failed to sync token with FastAPI backend:", syncErr);
          }
        }
        setAlertContent(loginData?.message);
        setAlertType("success");
        setAlert(true);

        setTimeout(() => {
          navigate("/");
        }, 1500);
      })

      .catch((err) => {
        const errorMessage =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          "An error occurred. Please try again later.";

        // Ensure message is a string for the Notification component
        setAlertContent(typeof errorMessage === 'string' ? errorMessage : JSON.stringify(errorMessage));
        setAlertType("error");
        setAlert(true);
      });
  };
  const { errors, touched, handleSubmit, getFieldProps } = formik;

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <section className="signup-container">
          <div className="signup_logo" style={{ paddingTop: "20px" }}>
            <img src={Logo} width={380} height={100} alt="logo" />
          </div>
          <h1
            className="global_text login_text"
            style={{ textAlign: "center" }}
          >
            Login
          </h1>
          <FormikProvider value={formik}>
            <Form
              autoComplete="off"
              className="login_form_Fields"
              noValidate
              onSubmit={handleSubmit}
            >
              <Field
                as={TextField}
                fullWidth
                autoComplete="username"
                placeholder="name@gmail.com"
                name="email"
                type="email"
                {...getFieldProps("email")}
                size="small"
                style={{ marginBottom: "8%" }}
                error={Boolean(touched.email && errors.email)}
                helperText={touched.email && errors.email}
              />

              <Field
                as={TextField}
                fullWidth
                autoComplete="off"
                placeholder="Enter your password here"
                name="password"
                type={showPassword ? "text" : "password"}
                //  error={props.errors.password && props.touched.password}
                size="small"
                {...getFieldProps("password")}
                onKeyDown={(e) => {
                  if (e.key === " ") {
                    e.preventDefault();
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleShowPassword} edge="end">
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                  style: {
                    height: "35px",
                  },
                }}
                error={Boolean(touched.password && errors.password)}
                helperText={touched.password && errors.password}
                style={{ marginBottom: "2.5%" }}
              //   className={classes.input_root}
              />
              {/* <div className="Signup_text"> */}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Link
                  className="login-text-color"
                  variant="subtitle2"
                  sx={{ cursor: "pointer" }}
                  onClick={() => navigate("/forgotpassword", { replace: true })}
                  style={{
                    fontSize: "16px",
                  }}
                >
                  Forgot Password?
                </Link>
              </div>

              <div className="signup_logo">
                <Button variant="contained" type="submit">
                  LOGIN
                </Button>
              </div>

              <Notification
                message={alertContent}
                open={alert}
                severity={alertType}
                onClose={handleAlert}
              />
            </Form>
          </FormikProvider>
        </section>
      </Grid>
    </Grid>
  );
};
export default Login;
